import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Building2 } from "lucide-react";

export default function AuthCallback() {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double-processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);

      if (!match) {
        navigate("/login", { replace: true });
        return;
      }

      const sessionId = match[1];

      try {
        const userData = await loginWithGoogle(sessionId);
        // Clean the URL fragment and redirect to dashboard
        window.history.replaceState(null, "", "/");
        navigate("/portfolio", { replace: true, state: { user: userData } });
      } catch (err) {
        console.error("Google auth failed:", err);
        navigate("/login", { replace: true });
      }
    };

    processSession();
  }, [loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 bg-[#D4AF37] flex items-center justify-center mx-auto mb-4">
          <Building2 className="w-6 h-6 text-black" strokeWidth={1.5} />
        </div>
        <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white/60 text-sm font-sans">Authenticating with Google...</p>
      </div>
    </div>
  );
}
